// extracted by mini-css-extract-plugin
export var container = "_dc-0";
export var containerTopRight = "_dc-1";